import type { JSX } from 'react';

/**
 * Forbidden — shown when the provider attempts to access a route they are not
 * authorized for. Renders no PHI and no technical details.
 */
export function Forbidden(): JSX.Element {
  return (
    <div role="main" className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-900">Access denied</h1>
        <p className="mt-2 text-gray-600">
          You don&apos;t have permission to view this page.
          <br />
          Contact{' '}
          <a href="mailto:support@nourishedrx.com" className="text-blue-600 underline">
            NourishedRx support
          </a>{' '}
          if you believe this is an error.
        </p>
      </div>
    </div>
  );
}
